import { IJSLComponent, IJSLVNode } from "jsl-render";
import { JSLRoute } from "jsl-route";
import { DialogComponent, InputComponent, StackPanelComponent } from "jsl-ui";
import { AjaxController } from "../../ajax/AjaxController";
import { ContactBoxComponent } from "./ContactBoxComponent";
import "./SearchTokenComponentStyle.scss";

export class SearchTokenComponent implements IJSLComponent{

    private projektPosId: string = "";
    private plz: string = "";
    private plzField: InputComponent;
    private projektPosField: InputComponent;

    public constructor() {
        this.init();
    }

    public render(): IJSLVNode {
        return <div class="main-comp">
            {new StackPanelComponent([<form>
                <div><h1>Auftragssuche nach Service-ID und Postleitzahl</h1></div>
                {new StackPanelComponent([
                    <label>Service-ID: </label>,
                    <div>{this.projektPosField}</div>
                ], {
                    sizes: ["15%", "20%"],
                    responsive: true,
                    class: "panel-comp"
                })}
                {new StackPanelComponent([
                    <label>Postleitzahl: </label>,
                    <div>{this.plzField}</div>
                ], {
                    sizes: ["15%", "20%"],
                    responsive: true,
                    class: "panel-comp"
                })}
                {new StackPanelComponent([<div></div>,
                <button style="submit" click={(e) => {
                    e.preventDefault();
                    AjaxController.SearchTokenAfterProjektPosAndPLZ(this.projektPosId, this.plz).then((token) => {
                        if (token && token !== "-") {
                            // console.log(token);
                            JSLRoute.navigate("status/"+token);
                        } else {
                            this.showErrorDialog(); //alert("Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!");    
                        }
                    }).catch((error) => {
                        this.showErrorDialog(); //alert("Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!");
                    });
                }}>Suche</button>], {
                    sizes: ["15%", "20%"],
                    responsive: true,
                    class: "panel-comp"
                })}</form>, 
                <div class="contact-comp">{new ContactBoxComponent()}</div>] , {
                    sizes: ["45%", "42%"],
                    responsive: true,
                    class: "panel-comp"
                })}
        </div>;
    }
    
    private init() {
        this.plzField = new InputComponent({
            value: this.plz + "",
            type: "input",
            placeholder: "Postleitzahl",
            onChange: (value: string) => {
                this.plz = value;
                const n = +this.plz;
                if (isNaN(n)) {
                    this.plz = "";
                    alert("Keine gültige Postleitzahl");
                    this.plzField.setValue(this.plz);
                }
            }
        });
        this.projektPosField = new InputComponent({
            value: this.projektPosId,
            type: "input",
            placeholder: "Service-ID",
            onChange: (value: string) => {
                this.projektPosId = value;
                const n = +this.projektPosId;
                if (isNaN(n)) {
                    this.projektPosId = "";
                    alert("Keine gültige Postleitzahl");
                    this.projektPosField.setValue(this.projektPosId);
                }
            }
        });
    }

    private showErrorDialog() {
        DialogComponent.show({
            header: "Fehler",
            content: <div>Es konnte kein Eintrag zu den angegebenen Daten gefunden werden!</div>,
            footer: DialogComponent.Ok(),
            // height: "5rem",
            maxWidth: "50rem",
            width: "75vw"
        });
    }
}